import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { postApiCall } from "./tokenService";

export const savePrint = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/print/save", SaveSuccess, JSON.stringify(obj));
};

export const removePrint = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/print/remove", ApiSuccess, JSON.stringify(obj));
};